// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_2 from 'D:/Projects/Aimer/AimerPay/src/models/merchant';
import model_3 from 'D:/Projects/Aimer/AimerPay/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from 'D:/Projects/Aimer/AimerPay/src/models/actingAsMerchant';

export const models = {
model_2: { namespace: 'merchant', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
model_1: { namespace: 'actingAsMerchant', model: model_1 },
} as const
